/**
 * Browser-side Umami analytics initialization
 *
 * Reads URL and website ID from build-time defines (injected by build.ts).
 * Only initializes when both values are non-empty.
 * Production-only by design: defines are only set during `bun run build`.
 */

declare const __UMAMI_URL__: string;
declare const __UMAMI_WEBSITE_ID__: string;

export function initUmami() {
  const url = typeof __UMAMI_URL__ !== "undefined" ? __UMAMI_URL__ : "";
  const websiteId = typeof __UMAMI_WEBSITE_ID__ !== "undefined" ? __UMAMI_WEBSITE_ID__ : "";
  if (!url || !websiteId) return;
  if (document.querySelector("script[data-website-id]")) return;

  const script = document.createElement("script");
  script.defer = true;
  script.src = `${url}/script.js`;
  script.setAttribute("data-website-id", websiteId);
  document.head.appendChild(script);
}

export function getUmamiDashboardUrl(): string | null {
  const url = typeof __UMAMI_URL__ !== "undefined" ? __UMAMI_URL__ : "";
  const websiteId = typeof __UMAMI_WEBSITE_ID__ !== "undefined" ? __UMAMI_WEBSITE_ID__ : "";
  if (!url || !websiteId) return null;
  return `${url}/websites/${websiteId}`;
}
